import { render, staticRenderFns } from "./AppTemplatePreviewCard.vue?vue&type=template&id=dd96e868"
import script from "./AppTemplatePreviewCard.vue?vue&type=script&lang=js"
export * from "./AppTemplatePreviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports